module.exports = __webpack_public_path__ + "static/media/tool-02.35eb06fa.png";